import { Text } from 'rsuite'
import { useSelector } from 'react-redux'
import useTranslation from '@/hooks/useTranslation'
import { configSelectors } from '@/store/configs'
import cn from 'classnames'
import styles from './footer.module.scss'

const Footer = ({ children, className }) => <div className={cn(styles.footer, 'footer', className)}>{children}</div>

const Copy = ({ children, className }) => <p className={cn(styles.footerCopy, className)}>{children}</p>

const FooterView = () => {
  const t = useTranslation()
  const isInFrame = useSelector(configSelectors.selectIsInFrame)
  const version = useSelector(configSelectors.selectVersion)

  if (isInFrame) return null
  const currentYear = new Date().getFullYear()

  return (
    <Footer>
      <div className="text-center">
        <Copy className="small">© {t('copyright', `Copyright 2022 - ${currentYear}. All rights reserved.`)}</Copy>
        {version?.version && <Text size="xs" className="small">{`v${version.version}/${version.apiVersion}`}</Text>}
      </div>
    </Footer>
  )
}

export default FooterView
